import { createIcon, Path } from './index';

export const IconChevronRight = createIcon({
  title: 'A right chevron',
  viewBox: '0 0 24 24',
  path: [
    <Path
      d="M9 18L15 12L9 6"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
      strokeLinejoin="round"
    />,
  ],
});
